import {LoadTask} from './LoadTask.js';

/**
 * Loads the Text at the specified endpoint. If the load is successful, the loaded text can be
 * accessed via the LoadTextTask object's .text property.
 */
export class LoadTextTask extends LoadTask {
  constructor (url, {headersObj = null, nocache = false, params = {}} = {}) {
    super(url,  {headersObj: headersObj, nocache: nocache, params: params});
    this.name = 'LOAD_TEXT';
    this.text = null;
  }

  handleSuccess (response) {
    response.text().then(text => {
      this.text = text;
      this.done();
    });
  }
}